const Options = [
    'All',
    'Text',
    'Checkbox',
    'Radio',
    'Yes / No'
]
export default Options;